<div class="notification block" [ngClass]="notificationStyle">
  <div *ngIf="layout === NotificationLayout.EDGE_TO_EDGE; else wrappedContentTpl" class="grid-max-width grid-col-12">
    <div class="col-1-12">
      <ng-container *ngTemplateOutlet="wrappedContentTpl"></ng-container>
    </div>
  </div>
</div>

<ng-template #wrappedContentTpl>
  <div
    class="flex flex--start"
    [ngClass]="{
      'ps-medium': !this.compact,
      'ps-xsmall': this.compact
    }"
  >
    <fcom-icon
      *ngIf="displayedIcon"
      class="message-type ms-xsmall-r flex--nogrow"
      [ngClass]="{ 'icon-small': compact, 'icon-medium': !compact }"
      [category]="iconCategory"
      [name]="displayedIcon"
    ></fcom-icon>

    <div
      class="flex flex-1"
      [ngClass]="{
        'flex--wrap': horizontal,
        'flex--column row-gap': !horizontal,
        'font-body-1': !compact,
        'font-body-2': compact
      }"
    >
      <span class="ps-xsmall-r flex-1 flex--self-start">
        <span *ngIf="title" class="bold-type block ms-xsmall-b">{{ title }}</span>
        <ng-content></ng-content>
      </span>
      <ng-container *ngIf="linkText">
        <div *ngIf="linkUrl">
          <a
            class="ms-xsmall-r link flex--self-start medium-type underline"
            [href]="linkUrl"
            [attr.target]="linkOpenInNewWindow ? '_blank' : null"
            [attr.rel]="linkOpenInNewWindow ? 'noopener noreferrer' : null"
            (click)="linkClick.emit($event)"
          >
            {{ linkText }}
          </a>
          <a
            *ngIf="secondaryLinkUrl && secondaryLinkText"
            class="ms-xsmall-r link flex--self-start medium-type underline"
            [href]="secondaryLinkUrl"
            [attr.target]="secondaryLinkOpenInNewWindow ? '_blank' : null"
            [attr.rel]="secondaryLinkOpenInNewWindow ? 'noopener noreferrer' : null"
            (click)="secondaryLinkClick.emit($event)"
          >
            {{ secondaryLinkText }}
          </a>
        </div>

        <div *ngIf="!linkUrl" class="flex--self-end">
          <fcom-button
            *ngIf="secondaryLinkText && !secondaryLinkUrl"
            [text]="secondaryLinkText"
            [theme]="ButtonTheme.TERTIARY"
            (click)="secondaryLinkClick.emit($event)"
          >
          </fcom-button>
          <fcom-button class="ms-small-l" [text]="linkText" (click)="linkClick.emit($event)"> </fcom-button>
        </div>
      </ng-container>
    </div>

    <div>
      <button
        *ngIf="isClosable"
        [attr.aria-label]="i18n.closeAriaLabel | finLocalization"
        (click)="closeClick.emit($event)"
        class="flex close-button circle ps-xxsmall"
      >
        <fcom-icon class="icon-small" [name]="'close-delete'"></fcom-icon>
      </button>
    </div>
  </div>
</ng-template>
